import { inject, Provider } from '@angular/core';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  SHOP_AROUND_LIST_BODY_BLOCK_DATA_SOURCE,
  ShopAroundListBodyBlockDataSource,
} from './shop-around-list-body-block-view-model';
import { ShopAroundListBodyBlockPreviewDataSource } from './shop-around-list-body-block-preview-data-source';
import { ShopAroundListBodyBlockStoreDataSource } from './shop-around-list-body-block-store-data-source';

export function provideShopAroundListBodyBlockDataSource(): Provider[] {
  return [
    ShopAroundListBodyBlockStoreDataSource,
    ShopAroundListBodyBlockPreviewDataSource,
    {
      provide: SHOP_AROUND_LIST_BODY_BLOCK_DATA_SOURCE,
      useFactory: (): ShopAroundListBodyBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(ShopAroundListBodyBlockPreviewDataSource)
          : inject(ShopAroundListBodyBlockStoreDataSource);
      },
    },
  ];
}
